import { render } from "./manageList.vue?vue&type=template&id=22fb83aa&scoped=true"
import script from "./manageList.vue?vue&type=script&lang=js"
export * from "./manageList.vue?vue&type=script&lang=js"

import "./manageList.vue?vue&type=style&index=0&id=22fb83aa&lang=scss&scoped=true"
import "./manageList.vue?vue&type=style&index=1&id=22fb83aa&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fb83aa"]])

export default __exports__